// extracted by mini-css-extract-plugin
module.exports = {"text":"ListHeading-module__text--1VE3C","primary":"ListHeading-module__primary--TR7TX","secondary":"ListHeading-module__secondary--1d0gd"};